import { useQuery, gql } from '@apollo/client';
import { useState } from 'react';

export const GET_PAGINATED_WORKING_CONDITIONS = gql`
  query getAllWorkingConditions($memberId: ObjectId!, $queryOptions: QueryOptionsInput) {
    getAllWorkingConditions(memberId: $memberId, queryOptions: $queryOptions) {
      collection {
        _id
        active
        employmentType
        contracts {
          hireDate
          contractType
          endDate
        }
        memberId
        companyId
        companyLocationId
        companyBusinessAddressId
        companyDepartmentId
        jobId
        jobSupervisorId
        occupationType
        mainOrSecondaryOccupation
        contractExpirationDate
        terminationDate
        lengthOfProbation
        probationType
        terminatedBy
        referencePeriod
        probationDate
        weeklyHours
        noticePeriod
        noticePeriodType
        paidVacation
        company {
          name
        }
        companyLocation {
          name
        }
        companyBusinessAddress {
          zipCode
          street
          city
          country
        }
        companyDepartment {
          name
          costCenter
        }
        job {
          title
        }
        jobSupervisor {
          supervisorJobTitle
          supervisorMember {
            profile {
              displayName
            }
          }
        }
      }
      totalCount
    }
  }
`;

export const useGetPaginatedWorkingConditions = (_id: string) => {
  const [currentPage, setPage] = useState(1);

  const pageSize = 1;

  const { data, loading } = useQuery(GET_PAGINATED_WORKING_CONDITIONS, {
    variables: {
      memberId: _id,
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
      },
    },
    skip: !_id,
    fetchPolicy: 'network-only',
  });

  const { totalCount = 0, collection = [] } = data?.getAllWorkingConditions || {};

  return {
    loading,
    workingCondition: collection[0],
    paginationConfig: {
      total: totalCount,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
  };
};

export const useGetWorkingConditions = (_id: string) => {
  const { data, loading } = useQuery(GET_PAGINATED_WORKING_CONDITIONS, {
    variables: {
      memberId: _id,
      queryOptions: {},
    },
    skip: !_id,
    fetchPolicy: 'network-only',
  });

  const { totalCount = 0, collection = [] } = data?.getAllWorkingConditions || {};

  return {
    loading,
    collection,
    totalCount,
  };
};
